export default "__VITE_ASSET__94d61e4a__"